import "@mantine/charts/styles.css";
import { MantineProvider, v8CssVariablesResolver } from "@mantine/core";
import "@mantine/core/styles.css";
import { DatesProvider } from "@mantine/dates";
import "@mantine/dates/styles.css";
import { Notifications } from "@mantine/notifications";
import "@mantine/notifications/styles.css";
import "@mantine/spotlight/styles.css";
import "@mantine/tiptap/styles.css";
import * as Sentry from "@sentry/browser";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import dayjs from "dayjs";
import "dayjs/locale/de";
import customParseFormat from "dayjs/plugin/customParseFormat";
import "mantine-react-table-open/styles.css";
import { type ErrorInfo, StrictMode } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { mantineTheme } from "../../mantine/mantineTheme";
import { theme } from "../../utils/constants";
import { SiteName } from "../../utils/enums";
import { ErrorFallback } from "../Layout/ErrorFallback";
import { Page } from "./Page";

const queryClient = new QueryClient();
window.__TANSTACK_QUERY_CLIENT__ = queryClient;

dayjs.extend(customParseFormat);
declare global {
  interface Window {
    SITE_NAME: SiteName;
    __TANSTACK_QUERY_CLIENT__: QueryClient;
  }
}

const siteName =
  theme === "roedl"
    ? SiteName.Smarendo
    : theme === "alva"
      ? SiteName.Alva
      : theme === "wavelr"
        ? SiteName.Wavelr
        : SiteName.Optinode;
window.SITE_NAME = siteName;

export const logError = (error: unknown, info: ErrorInfo) => {
  Sentry.captureException(error, { extra: { ...info } });
};

function App() {
  return (
    <StrictMode>
      <MantineProvider
        cssVariablesResolver={v8CssVariablesResolver}
        theme={mantineTheme}
      >
        <DatesProvider settings={{ consistentWeeks: true, locale: "de" }}>
          <QueryClientProvider client={queryClient}>
            <Notifications />
            <ErrorBoundary FallbackComponent={ErrorFallback} onError={logError}>
              <Page />
            </ErrorBoundary>
          </QueryClientProvider>
        </DatesProvider>
      </MantineProvider>
    </StrictMode>
  );
}

export { App };
